import type { GameLevel } from '../../types/game';

// Solution: Black = 2, 6, 10 | Sheriff = 5 | Red = 1, 3, 4, 7, 8, 9
//
// Deduction path:
// 1. Hint 2 (no black claimed sheriff) → seat 5 is real sheriff
// 2. Sheriff checks: 2=black, 6=black → 2 blacks identified
// 3. Hint 1 (parity triggered after day 2 eviction):
//    after eviction → 6 alive (1,2,5,6,8,10) with 3 blacks
//    known blacks: 2 and 6 → 3rd black among 1,8,10
// 4. Hint 3 (seats 1 and 8 are red) → 10 = black (3rd black by elimination)
// 5. Night kills (3,7) are red → confirms axiom
// Parity check: after day 2 eviction of seat 9, alive = 1,2,5,6,8,10 → 3 black (2,6,10) vs 3 red (1,5,8) → parity!

export const LEVEL_003: GameLevel = {
  id: 'level-003',
  title: 'Паритет',
  difficulty: 'intermediate',
  brief: `Детектив, в этом деле мафия одержала победу.

Первой ночью был убит Игрок 3. Первое заседание закончилось выдворением Игрока 4 — красного, как выяснилось позже. Мафия грамотно направляла голоса.

Второй ночью жертвой стал Игрок 7. На втором заседании наконец вскрылся Шериф. Но было поздно: мафия переключила стол на Игрока 9, и после его выдворения наступил паритет — по три с каждой стороны.

Кто стоял за этой схемой? Восстановите картину.`,

  nights: [
    { night: 1, killedPlayer: 3 },
    { night: 2, killedPlayer: 7 },
  ],

  days: [
    {
      day: 1,
      votes: [
        { voter: 1, target: 4 },
        { voter: 2, target: 5 },
        { voter: 4, target: 2 },
        { voter: 5, target: 4 },
        { voter: 6, target: 4 },
        { voter: 7, target: 4 },
        { voter: 8, target: 4 },
        { voter: 9, target: 6 },
        { voter: 10, target: 5 },
      ],
      evictedPlayer: 4,
    },
    {
      day: 2,
      votes: [
        { voter: 1, target: 9 },
        { voter: 2, target: 9 },
        { voter: 5, target: 6 },
        { voter: 6, target: 5 },
        { voter: 8, target: 9 },
        { voter: 9, target: 6 },
        { voter: 10, target: 9 },
      ],
      evictedPlayer: 9,
    },
  ],

  sheriffClaims: [
    {
      claimant: 5,
      day: 2,
      checks: [
        { night: 1, checkedPlayer: 2, result: 'black' },
        { night: 2, checkedPlayer: 6, result: 'black' },
      ],
    },
  ],

  hints: [
    {
      id: 'h1',
      type: 'parity',
      text: 'Игра закончилась на втором дне — после голосования наступил паритет: чёрных и красных стало поровну.',
    },
    {
      id: 'h2',
      type: 'behavior',
      text: 'В этой партии ни один чёрный игрок не объявлял себя Шерифом.',
    },
    {
      id: 'h3',
      type: 'arithmetic',
      text: 'Среди игроков 1 и 8 нет ни одного чёрного.',
    },
  ],

  solution: {
    1: 'red',
    2: 'black',
    3: 'red',
    4: 'red',
    5: 'sheriff',
    6: 'black',
    7: 'red',
    8: 'red',
    9: 'red',
    10: 'black',
  },
};
